import { render, staticRenderFns } from "./mainTwo.vue?vue&type=template&id=6dce5ba6&scoped=true&"
import script from "./mainTwo.vue?vue&type=script&lang=js&"
export * from "./mainTwo.vue?vue&type=script&lang=js&"
import style0 from "./mainTwo.vue?vue&type=style&index=0&id=6dce5ba6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dce5ba6",
  null
  
)

export default component.exports